import type {
  Phone,
  GetPhonesRequest,
  PhonePost,
} from '@/apis/generated/dialbunny';
import { PhoneFromJSON } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type PhoneListItemStore = StoreEntity<
  Phone,
  'e164',
  GetPhonesRequest,
  PhonePost,
  PhonePost
>;

export const usePhoneStore = apiStoreFactory<
  PhoneListItemStore['entity'],
  PhoneListItemStore['id'],
  PhoneListItemStore['filter'],
  PhoneListItemStore['createInput'],
  PhoneListItemStore['updateInput']
>(
  STORE.PHONE,
  { entityIdKey: 'e164' },
  {
    update: async (id, updateInput, { dialbunnyApi }) => {
      return await dialbunnyApi.updatePhone({
        e164: id,
        phonePost: updateInput,
      });
    },
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getPhonesRaw(filter, { signal });
    },
    read: async (number: string, { dialbunnyApi }) => {
      return await dialbunnyApi.getPhone({ e164: number });
    },
    bulkRead: async (numbers: string[], { dialbunnyApi }) => {
      const items = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Phone',
        ids: numbers.join(','),
      });

      return items.map(PhoneFromJSON);
    },
    discard: async (e164: string, { dialbunnyApi }) => {
      await dialbunnyApi.deletePhone({ e164 });
    },
  },
);
